import styled from '@emotion/styled/macro'

import { flexCenter, pageContentDefaultSize } from 'style/emotion'
import mediaQuery from 'share/utils/mediaQuery'

const CourseConfirmContainer = styled('div')`
  ${pageContentDefaultSize}

  color: var(--CINight);
  margin-top: 48px;

  ${mediaQuery('tablet')} {
    margin-top: 24px;
  }
`

const CourseConfirmCardWrapper = styled('div')`
  margin-bottom: 32px;

  ${mediaQuery('desktop', 'tablet')} {
    padding-left: 94px;
    padding-right: 94px;
  }

  ${mediaQuery('', 'desktop')} {
    padding-left: 100px;
    padding-right: 100px;
  }
`

const CourseConfirmCardFooter = styled('div')`
  ${flexCenter}

  height: auto;

  > * + * {
    margin-left: 8px;
  }

  > .mdi {
    font-size: 1.5rem;
  }
`

export {
  CourseConfirmCardFooter,
  CourseConfirmCardWrapper,
  CourseConfirmContainer
}
